<template>
  <div class="disclaimer-wrapper">
    <section id="disclaimer">
      <h2>免责声明</h2>
      <div class="legal-page">
        <h1>免责声明</h1>
        <p class="updated-at">最后更新日期：2025 年 1 月 1 日</p>

        <p>
          本免责声明适用于由
          <strong>登竣实业（上海）有限公司</strong>
          （以下简称"我们"）运营的网站及其相关服务，包括产品信息展示、留言咨询与 AI
          互动功能。访问和使用本网站，即表示您已阅读并理解本免责声明的全部内容。
        </p>

        <section>
          <h2>一、产品信息与内容准确性声明</h2>
          <p>
            本网站展示的产品图片、包装示意、技术参数、说明文字仅供参考。由于拍摄环境、显示设备、产品批次等因素，实际产品可能存在一定差异。
          </p>
          <p>网站内容旨在提供一般性参考，相关信息不构成任何形式的合同承诺或要约。</p>
          <p>产品的最终规格、参数、颜色、包装、价格等信息，以我们正式提供的报价单、合同或书面确认文件为准。</p>
        </section>

        <section>
          <h2>二、AI 服务免责声明（DeepSeek API）</h2>
          <p>
            本网站提供的 AI 助手服务基于包括 DeepSeek API 在内的技术实现，其生成内容由人工智能模型自动生成。
            您理解并同意：
          </p>
          <ul>
            <li>AI 回复可能包含不准确、不完整、不适用于当前情境的内容；</li>
            <li>AI 内容仅供参考，不构成专业意见或技术建议；</li>
            <li>AI 回复不应视为我们对任何事项的承诺、保证或最终答案；</li>
            <li>AI 生成内容不代表登竣实业（上海）有限公司的观点立场；</li>
            <li>对于因您完全依赖 AI 内容造成的直接或间接损失，我们不承担责任。</li>
          </ul>
          <p>
            为保护您的隐私和数据安全，我们建议您避免在对话中输入任何敏感个人信息（如身份证号码、银行资料、个人隐私等）。
          </p>
        </section>

        <section>
          <h2>三、用户行为责任自负声明</h2>
          <p>在使用本网站的留言功能或 AI 互动功能时，您应对自己输入的内容承担全部责任，并承诺不从事以下行为：</p>
          <ul>
            <li>发布违法、违规、政治敏感、暴力、色情或不当内容；</li>
            <li>发布侵犯他人知识产权、隐私权、名誉权的内容；</li>
            <li>提交虚假、恶意、诽谤性信息；</li>
            <li>利用本网站进行诈骗、骚扰或不正当目的；</li>
            <li>通过技术手段攻击、干扰或破坏网站安全。</li>
          </ul>
          <p>
            如您违反上述行为规范或导致他人损失，您将自行承担全部法律责任，我们不承担相关连带责任。
          </p>
        </section>

        <section>
          <h2>四、外部链接与第三方内容声明</h2>
          <p>
            本网站可能包含指向第三方网站或服务的链接。这些外部站点并非由我们控制，其内容、安全性、合法性与隐私政策均由第三方自行负责。
          </p>
          <p>
            您访问第三方网站所产生的风险将由您自行承担，我们不对因此造成的任何损失负责。
          </p>
        </section>

        <section>
          <h2>五、网站服务可用性</h2>
          <p>
            我们致力于保障网站稳定运行，但不保证网站随时可用或不发生中断。可能导致短暂不可用的情况包括：
          </p>
          <ul>
            <li>服务器维护或升级；</li>
            <li>网络故障或不可控的技术问题；</li>
            <li>不可抗力事件（包括但不限于自然灾害、政策调整等）；</li>
            <li>第三方服务故障。</li>
          </ul>
          <p>
            因上述情况导致您无法正常访问或使用本网站而产生的损失，我们不承担赔偿责任。
          </p>
        </section>

        <section>
          <h2>六、责任限制</h2>
          <p>在适用法律允许的最大范围内，我们声明：</p>
          <ul>
            <li>对因使用或无法使用本网站所造成的经济损失，我们不承担责任；</li>
            <li>对因依赖网站内容或 AI 生成内容所造成的损失，我们不承担责任；</li>
            <li>对您传输的数据丢失、泄露、篡改等情况导致的损失，我们不承担责任；</li>
            <li>
              对因第三方原因（例如 DeepSeek API 故障、网络供应商问题）导致的后果，我们不承担责任。
            </li>
          </ul>
          <p>以上责任限制不适用于法律法规明确不能免责的情形。</p>
        </section>

        <section>
          <h2>七、本免责声明的更新</h2>
          <p>
            我们可能因业务发展或法律法规变化对本免责声明进行更新。更新后的版本将在本页面发布并自发布之日起生效。
            建议您定期查看本页面以获取最新内容。
          </p>
        </section>

        <section>
          <h2>八、联系我们</h2>
          <p>如您对本免责声明有任何问题或反馈，可通过以下方式与我们联系：</p>
          <p>
            登竣实业（上海）有限公司<br />
            邮箱：2302137948@qq.com<br />
            地址：上海市宝山区罗泾镇银石路288号
          </p>
        </section>
      </div>
    </section>
    <div class="divider"></div>
  </div>
</template>

<script>
export default {
  name: 'DisclaimerView',
  mounted() {
    console.log('免责声明视图已挂载');
  }
}
</script>

<style scoped>
.disclaimer-wrapper {
  width: 100%;
  padding-top: 0;
}

#disclaimer {
  min-height: auto;
  padding: 20px 0 60px 0; /* 与其他页面保持一致的高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

#disclaimer > h2 {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: white;
}

.legal-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px;
  line-height: 1.7;
  font-size: 14px;
  color: #f5f5f5;
  background: #222;
  border-radius: 10px;
  text-align: left;
  width: 80%;
}

.legal-page h1 {
  font-size: 24px;
  margin-bottom: 8px;
  color: white;
}

.legal-page .updated-at {
  font-size: 13px;
  color: #999;
  margin-bottom: 20px;
}

.legal-page section {
  margin-bottom: 30px;
}

.legal-page h2 {
  font-size: 18px;
  margin-top: 24px;
  margin-bottom: 12px;
  color: white;
  border-bottom: 2px solid #e50914;
  padding-bottom: 8px;
}

.legal-page p {
  margin: 12px 0;
  line-height: 1.8;
}

.legal-page strong {
  color: #e50914;
  font-weight: 600;
}

.legal-page ul {
  padding-left: 24px;
  margin: 8px 0 16px;
}

.legal-page li {
  margin: 6px 0;
  line-height: 1.7;
}

.divider {
  width: 80%;
  max-width: 1200px;
  height: 2px;
  background: #e50914;
  margin: 0 auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .legal-page {
    width: 90%;
    padding: 24px 16px;
    font-size: 13px;
  }

  .legal-page h2 {
    font-size: 16px;
  }

  .legal-page h1 {
    font-size: 20px;
  }
}
</style>

